<template>
    <div class="modal fade" id="deleteTagForKeyword" tabindex="-1" role="dialog" aria-labelledby="confirmSingleDeleteProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete tags for {{ getHeading(keyTagToDel)}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closePopUpAction">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
				<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
					<div
					class="spinner-border"
					style="margin:40px auto;display:block;"
					></div>
				</div>
                <div class="modal-body" v-else>
					<div class="form-group row">
						<label class="col-sm-5 col-form-label" for="exampleCheck1" style = "padding-top:0px">Apply changes to all the other keywords</label>
						<div class="col-sm-7 pr-5">
							<input
								type="checkbox"
								v-model="isDelAll"
								value="true"
								style="padding-bottom:5px"
								class="form-check-input"
								id="exampleCheck1"
								autocomplete = "off"
							>
						</div>
					</div>
						<div class="form-group row">
						<label class="col-sm-5 col-form-label" for="exampleCheck1">Remove tags you want to delete</label>
						<div class="col-sm-7 pr-5">
							<multiselect
								v-model="tags"
								:options="tags"
								:searchable="false"
								ref="multiselect"
								label="title"
								track-by="title"
								open-direction="bottom"
								placeholder="All tags removed"
								:taggable="false"
								class="form-control borderless multi-dropdown col-md-12"
								:multiple="true"
								id="keywordTags"
								deselectLabel
								selectedLabel
								selectLabel
								:closeOnSelect="false"
								@remove="removedTag"
								:maxHeight="0"
								:disabled = "checkDisabled"
								>

							</multiselect>
						</div>
					</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "closePopUpAction">No</button>
                    <button type="button" @click="deleteSelectedTags()" class="btn btn-primary" v-if="tags.length || tagsToDelt.length">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name:'DeleteTag',
    data() {
        return {
			isLoading:false,
			tags:[],
			isDelAll:false,
			tagsToDelt:[],
			checkDisabled: false
        }
    },
	components:{Multiselect},
    props: ["keyTagToDel"],
	computed:{
	},
	watch:{
		keyTagToDel(){
			this.isLoading = true;
			let payload = {}
			if(this.$route.params.sponsoredType == 'sd'){
				 payload = {
					target_id:this.keyTagToDel.target_id,
					ams_campaign_id:this.keyTagToDel.ams_campaign_id,
					type:'asin'
				}
			}
			else{
				 payload = {
					ams_keyword_id:this.keyTagToDel.ams_keyword_id,
					ams_campaign_id:this.keyTagToDel.ams_campaign_id,
					type:'keyword'
				}
			}
			let vm = this;
			this.$store.dispatch("campaign/getTagsForAKeyword", payload).then((res) => {
				vm.tags = res;
				vm.isLoading = false;
			})
		},
		tags(){
			if(this.tags.length==0){
				this.checkDisabled = true
			}
			else{
				this.checkDisabled = false
			}
		}
	},
	mounted(){

	},
    methods: {
		getHeading(keyTagToDel){
			if(this.$route.params.sponsoredType=='sd' && keyTagToDel && keyTagToDel.asin){
				return keyTagToDel.asin
			}
			else if(keyTagToDel && keyTagToDel.keyword_text){
				return keyTagToDel.keyword_text
			}
			else return ''

		},
		removedTag(tag){
			if(tag.tag_id)
			this.tagsToDelt.push(tag)
		},
		deleteSelectedTags(){
			
			//let list = this.tags.map((e) => e.tag_id)
			let list = this.tagsToDelt.map((e) => e.tag_id)
			let payload = {
				ams_campaign_id:this.keyTagToDel.ams_campaign_id,
				tags:list,
				isDelAll:this.isDelAll
			}
			if(this.$route.params.sponsoredType=='sd'){
				payload['target_id'] = this.keyTagToDel.target_id,
				payload['type']='asin'
			}
			else{
				payload['ams_keyword_id'] = this.keyTagToDel.ams_keyword_id,
				payload['type']='keyword'
			}
			this.isLoading = true;
			let vm = this;
			this.$store.dispatch('campaign/delMutipleTgsForAKeyword', payload).then((res) => {
				vm.isLoading = true;
				vm.$emit("closeDelTagPopUp")
			})
		},
		closePopUpAction(){
			this.$emit("closeDelTagPopUp")
		}
    },
}
</script>

<style lang="scss">
.borderless{
	.multiselect__select{
		display: none
	}
	.multiselect__tags{
		padding-right:5px !important
	}
	&.form-control{
		border:0px solid white !important;
		margin-left:-26px !important
	}
}

.borderless.form-control:focus{
	box-shadow: none
}


</style>
